const GET_PRODUCTION_SUMMARY_LIST = 'GET_PRODUCTION_SUMMARY_LIST'
const GET_PRODUCTION_SUMMARY_LIST_SUCCESS = 'GET_PRODUCTION_SUMMARY_LIST_SUCCESS'


const ProductionSummaryType = {
  GET_PRODUCTION_SUMMARY_LIST,
  GET_PRODUCTION_SUMMARY_LIST_SUCCESS

}

export default ProductionSummaryType
